module.exports = __webpack_public_path__ + "img/csd.466f67a9.jpg";